var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientGradeSetupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88579 11.1068V13.8827H0.136757C0.0612878 13.8827 9.24788e-05 13.8218 3.77913e-05 13.7463C-0.00026299 13.2676 0.00132295 12.3287 0.00156904 11.1071C0.00156904 11.0316 0.0625456 10.9701 0.138014 10.9701H2.74907C2.82481 10.9701 2.88579 11.0313 2.88579 11.1068Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45381 8.87097H3.84275C3.76725 8.87097 3.70605 8.93217 3.70605 9.00766V13.8828H6.59053V9.00769C6.59053 8.93219 6.52931 8.87097 6.45381 8.87097Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1579 6.09033H7.54685C7.47135 6.09033 7.41016 6.15153 7.41016 6.22702V13.8828H10.2946V6.22702C10.2946 6.15155 10.2334 6.09033 10.1579 6.09033Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.863 11.512H11.2519C11.1764 11.512 11.1152 11.5732 11.1152 11.6487V13.8827H13.863C13.9384 13.8827 13.9997 13.8214 13.9997 13.7459V11.6487C13.9996 11.5732 13.9384 11.512 13.863 11.512Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82987 1.76917C7.87745 1.83616 7.90398 1.91598 7.90562 1.99828L7.91806 2.61163C7.92057 2.73544 8.04173 2.82185 8.15961 2.78384L8.72555 2.60143C8.76629 2.58831 8.80895 2.58174 8.8513 2.58174C8.89368 2.58174 8.93607 2.58831 8.97681 2.60143L9.54496 2.78392C9.663 2.82185 9.78419 2.73512 9.78635 2.61114L9.79704 1.99965C9.79841 1.91653 9.8252 1.83589 9.87333 1.76835L10.2149 1.29044C10.2861 1.19096 10.2427 1.05107 10.1278 1.0092L9.54878 0.798302C9.47578 0.771779 9.41182 0.725021 9.36452 0.663525L8.99871 0.189275C8.92483 0.0934625 8.78034 0.0932985 8.70621 0.18892L8.33759 0.664345C8.29029 0.725322 8.22658 0.771806 8.15414 0.798029L7.57654 1.00926C7.46196 1.05115 7.41868 1.19058 7.48934 1.29L7.82987 1.76917Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientGradeSetupIcon);
export default __webpack_public_path__ + "static/media/client-grade-setup-icon.049ff1ad.svg";
export { ForwardRef as ReactComponent };